import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Helmet } from "react-helmet";
import { legal } from "../data/legal";

// Breadcrumb trail + BreadcrumbList JSON-LD. `items` = [{label, to?}].
export default function Breadcrumbs({ items }) {
  const ld = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.label,
      ...(it.to ? { item: `${legal.siteUrl}${it.to}` } : {}),
    })),
  };

  return (
    <nav aria-label="Breadcrumb" className="container-page pt-6">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(ld)}</script>
      </Helmet>
      <ol className="flex flex-wrap items-center gap-1 text-xs text-acBlack/50">
        {items.map((it, i) => (
          <li key={i} className="flex items-center gap-1">
            {it.to ? (
              <Link to={it.to} className="hover:text-acAccent">
                {it.label}
              </Link>
            ) : (
              <span className="text-acBlack/70">{it.label}</span>
            )}
            {i < items.length - 1 && (
              <ChevronRight className="h-3.5 w-3.5 text-acBlack/30" />
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
